export default "__VITE_PUBLIC_ASSET__5204b457__"